import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { AssistantTrigger } from '@/components/assistant';
import { UserMenu, GroupSelector } from '@/components/auth';
import { useAuth } from '@/contexts/AuthContext';

const navItems = [
  { path: '/trajectories', label: 'Trajectories' },
  { path: '/agents', label: 'Agents' },
  { path: '/evals', label: 'Evals' },
  { path: '/monitoring', label: 'Monitoring' },
  { path: '/schedules', label: 'Schedules' },
  { path: '/notebooks', label: 'Notebooks' },
  { path: '/developer', label: 'Developer' },
];

export function TopNavigation() {
  const location = useLocation();

  // Find the current tab based on path (longest match wins)
  const currentTab = navItems
    .filter((item) => location.pathname.startsWith(item.path))
    .sort((a, b) => b.path.length - a.path.length)[0]?.path || '/trajectories';

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-14 items-center">
        <Link to="/home" className="flex items-center gap-2 mr-6">
          <span className="font-bold text-xl">Green Firefly</span>
        </Link>

        <Tabs value={currentTab} className="flex-1">
          <TabsList className="bg-transparent h-14 p-0 gap-4">
            {navItems.map((item) => (
              <TabsTrigger
                key={item.path}
                value={item.path}
                asChild
                className={cn(
                  'h-14 px-4 rounded-none border-b-2 border-transparent',
                  'data-[state=active]:border-primary data-[state=active]:bg-transparent',
                  'data-[state=active]:shadow-none'
                )}
              >
                <Link to={item.path}>{item.label}</Link>
              </TabsTrigger>
            ))}
          </TabsList>
        </Tabs>

        {/* Right side: Group selector, Assistant trigger, User menu */}
        <div className="flex items-center gap-2">
          <GroupSelector />
          <AssistantTrigger />
          <UserMenu />
        </div>
      </div>
    </header>
  );
}

export default TopNavigation;
